import { gql } from '@urql/core';
import React from 'react';
import { Espin_Game_Definition_Enum, PrimaryGameCardFragment } from '../../generated/spin-graphql';
import { getGameIconFromEnum } from '../../utils/GameUtils';
import { ExternalLink } from '../common/ExternalLink';
import { GameIcon } from '../icons/GameIcon';

type Props = {
    primaryGame: PrimaryGameCardFragment;
};
gql`
    fragment PrimaryGameCard on espin_player_game {
        game {
            name
            game_definition
        }
        rank
        role
        tracker
    }
`;

export const PrimaryGameCard: React.FC<Props> = ({ primaryGame }) => {
    return (
        <div className="profile-card dark-theme primary-game-card">
            <div className="title-container">
                <h2 className="title">Primary Game</h2>
                <p className="subtitle">{primaryGame.game.name}</p>

                <div className="game-info">
                    <div className="primary-game-info-container">
                        <p className="info-label">Rank</p>
                        <p className="info-value">{primaryGame.rank || 'Unknown'}</p>
                    </div>
                    <div className="primary-game-info-container">
                        <p className="info-label">Role</p>
                        <p className="info-value">{primaryGame.role || 'Unknown'}</p>
                    </div>
                </div>
                {primaryGame.tracker && (
                    <ExternalLink
                        ariaLabel={'Tracker.gg'}
                        className={'info-button dark-theme'}
                        label={'TRACKER.GG'}
                        link={primaryGame.tracker}
                    />
                )}
                <GameIcon
                    className="primary-game-icon"
                    gameName={primaryGame.game.name}
                    game={primaryGame.game.game_definition}
                />
            </div>
        </div>
    );
};
